import React from 'react';

import { IconContext } from 'react-icons';
import { ConditionIcons } from 'components';
import { temperatureColorScale } from 'utils/colorUtils';

export default function CustomIcon({ city_name, temperature, icon, icon_name, compact = false }) {
  const textSize = compact ? 18 : 24;
  const iconSize = compact ? 42 : 64;
  const padding = compact ? 6 : 10;
  const textShadow = compact
    ? '-1px 0 black, 0 1px black, 1px 0 black, 0 -1px black'
    : '-2px 0 black, 0 2px black, 2px 0 black, 0 -2px black';

  return (
    <div
      style={{
        borderRadius: '5px',
        padding,
        textAlign: 'center',
        color: temperatureColorScale(temperature),
        textShadow,
      }}
    >
      <p style={{ margin: 0, fontSize: textSize, fontWeight: 'bold', lineHeight: 1.05 }}>
        {temperature}°F
      </p>

      <IconContext.Provider
        value={{
          size: iconSize,
          style: {
            textShadow,
            stroke: 'black',
            strokeWidth: '.5px',
          },
        }}
      >
        <ConditionIcons conditionId={icon} />
      </IconContext.Provider>
    </div>
  );
}
